import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsOpen(false);
    } else if (id === 'top') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setIsOpen(false);
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm border-b border-gray-200 py-2 shadow-sm' : 'bg-transparent py-4'}`} data-id="element-91">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="flex justify-between items-center" data-id="element-93">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-94">
            <span className={`text-xl font-bold tracking-tight transition-colors ${isScrolled ? 'text-[#1f2933]' : 'text-white'}`} data-id="element-95">
              Netanel Tours VIP
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-96">
            <button onClick={() => scrollToSection('top')} className={`font-medium transition-colors ${isScrolled ? 'text-[#1f2933] hover:text-[#4b5563]' : 'text-white/90 hover:text-white'}`} data-id="element-97">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className={`font-medium transition-colors ${isScrolled ? 'text-[#1f2933] hover:text-[#4b5563]' : 'text-white/90 hover:text-white'}`} data-id="element-98">
              Services
            </button>
            <button onClick={() => scrollToSection('plan-trip')} className={`font-medium transition-colors ${isScrolled ? 'text-[#1f2933] hover:text-[#4b5563]' : 'text-white/90 hover:text-white'}`} data-id="element-99">
              Plan My Trip
            </button>
            <button onClick={() => scrollToSection('contact')} className={`px-5 py-2 rounded-md font-medium transition-colors ${isScrolled ? 'bg-[#1f2933] text-white hover:bg-[#374151]' : 'bg-white text-[#1f2933] hover:bg-gray-100'}`} data-id="element-100">
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-101">
            <button onClick={() => setIsOpen(!isOpen)} className={`p-2 transition-colors ${isScrolled ? 'text-[#1f2933]' : 'text-white'}`} aria-label="Toggle menu" data-id="element-102">
              {isOpen ? <X className="h-6 w-6" data-id="element-103" /> : <Menu className="h-6 w-6" data-id="element-104" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-b border-gray-200 absolute top-full left-0 w-full shadow-lg" data-id="element-105">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-106">
            <button onClick={() => scrollToSection('top')} className="block w-full text-left px-3 py-3 text-[#1f2933] hover:bg-gray-50 rounded-md font-medium border-b border-gray-100" data-id="element-107">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-3 py-3 text-[#1f2933] hover:bg-gray-50 rounded-md font-medium border-b border-gray-100" data-id="element-108">
              Services
            </button>
            <button onClick={() => scrollToSection('plan-trip')} className="block w-full text-left px-3 py-3 text-[#1f2933] hover:bg-gray-50 rounded-md font-medium border-b border-gray-100" data-id="element-109">
              Plan My Trip
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-3 py-3 mt-4 bg-[#1f2933] text-white rounded-md font-medium text-center" data-id="element-110">
              Contact Us
            </button>
          </div>
        </div>}
    </nav>;
}